import { MenuItem } from '@mui/material'
import { SendReminder } from 'components/core/task/send_reminder/index'
import { TaskValue } from 'lib/actions/task'
import { useSimpleModal } from 'lib/modals'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type SendReminderDropdownOptionProps = {
    task: TaskValue
    close: () => void
}

export const SendReminderDropdownOption: FC<SendReminderDropdownOptionProps> = ({ task, close }) => {
    const { open } = useSimpleModal()
    const handleClick = (): void => {
        open(SendReminder, { taskID: task.id })()
        close()
    }

    return <MenuItem
        onClick={handleClick}
        key={`components_task_list_send_reminder_option_${task.id}`}
    >
        <FormattedMessage id="components_task_list_send_reminder_option" defaultMessage="Send reminder" />
    </MenuItem>
}
